if (!customElements.get('character-count')) {
  customElements.define(
    'character-count',
    class CharacterCount extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('keyup', this.onKeyUpHandler.bind(this));
      }

      onKeyUpHandler(event) {
        event.target.parentElement.dataset.charactersUsed = event.target.value.length;
      }
    }
  );
}
